import { Pipe, PipeTransform } from "@angular/core";
/**
 * 반올림 pipe
 */
@Pipe({
  name: 'fixed'
})
export class FloatFixedPipe implements PipeTransform {

  transform(num: number | undefined, fixed: number = 1): number | string | undefined {
    if (num === undefined) {
      return 
    }
    if (isFloat(num)) {
      return num.toFixed(fixed);
    }
    return num;
  }
}

const isInt = (num: number): boolean => {
  if (Number(num) !== num) {
    return false;
  }
  return num % 1 === 0
}

const isFloat = (num: number): boolean => {
  if (Number(num) !== num) {
    return false;
  }
  return num % 1 !== 0
}
